import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReportIcon from "@mui/icons-material/Report";
import SettingsInputSvideoIcon from "@mui/icons-material/SettingsInputSvideo";
import Logo from "../src/img/logo.png";
import { useAppContext } from "./Lib/ContextLib";


export default function SideBar() {
  const history = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = React.useState({});

  React.useEffect(() => {
    const path = location.pathname.split("/")[1];
    const menuMap = {
      "admin-list": "8",
      "access-user": "8",
      "playerlist": "1",
      "live-player-app": "1",
      "live-player-game": "1",
      "playerbanned": "1",
      "android-player": "1",
      "ios-player": "1",
      "pending-kyc-player": "1",
      "tournament-list": "2",
      "ludo-tournament-list": "10",
      "chess-tournament-list": "10",
      "block-blast-tournament-list": "10",
      "candy-blast-tournament-list": "10",
      "notification": "12",
      "banner": "6",
      "version": "6",
      "cms": "6",
      "spin-wheel": "6",
      "restrictedarea": "6",
      "poll": "6",
      "faq": "6",
      "bot-form": "6",
      "room-tier": "6",
      "notice": "6",
      "coin-package": "6",
      "social": "6",
      "history": "4",
      "payout": "4",
      "bet": "4",
      "win": "4",
      "addcash": "4",
      "income-details": "9",
      "ludo-income": "9",
      "bonus": "9",
      "game-handle": "9",
      "game-version": "9",
      "withdraw": "9",
      "addmoney": "9",
      "reports-player": "7",
      "history-reports": "7",
      "tds-report": "7",
      "gst-report": "7",
    };

    const key = menuMap[path];
    if (key) {
      setOpenMenus({ [key]: true });
    }
  }, [location.pathname]);

  

  const {
    // showPage,
    setShowPage,
                                                                                                setAddNewPlayer,
    accessObject,
  } = useAppContext();

  return (
    <div>
      <aside
        className="main-sidebar elevation-4"
        style={{ backgroundColor: "#111b20", position: "fixed" }}
      >
        <a
          href="/dashboard"
          className="brand-link "
          style={{
            display: "flex",
            justifyContent: "center",
            height: "70px",
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{ opacity: "0.8", width: "70%", height: "50px" }}
          />
        </a>
        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* dashboard */}
              {accessObject?.dashboardCount === true && (
                <div className="nav-item ">
                  <div
                    className={`nav-link ${
                      location.pathname.split("/")[1] === "dashboard" &&
                      "active"
                    }`}
                    id="dashboard"
                    onClick={() => {
                      history("/dashboard");
                                                                                                                                                                                                                                                                                            }}
                  >
                    <i
                      className="nav-icon fas fa-tachometer-alt mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">Dashboard</p>
                  </div>
                </div>
              )}
              {/* Admin */}
              {(accessObject?.getAdminList === true ||
                accessObject?.adminAccessUser === true) && (
                <li className={`nav-item mt-2 ${openMenus['8'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fas fa-user  mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Admin
                      <i
                        className={` ${
                          (!openMenus['8']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['8']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getAdminList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "admin-list" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/admin-list");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Admin List
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* player */}
              {(accessObject?.getPlayerList === true ||
                accessObject?.getPlayerBannedList === true ||
                accessObject?.getLivePlayerAppList === true ||
                accessObject?.getLivePlayerGameList === true) && (
                <li className={`nav-item mt-2 ${openMenus['1'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fa fa-user-circle mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Player
                      <i
                        className={` ${
                          (!openMenus['1']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['1']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getPlayerList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "playerlist" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/playerlist", { state: { data: "All" } });
                            setShowPage(false);
                            setAddNewPlayer(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Total Players
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getLivePlayerAppList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "live-player-app" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/live-player-app");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Live Players
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getPlayerBannedList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "playerbanned" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/playerbanned");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Banned Players
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* Tournament */}
              {/* {accessObject?.getEightBallPoolLiteTour === true && (
                <li className="nav-item mt-2">
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fas fa-trophy  mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Tournament
                      <i
                        className={` ${
                          (!openMenus['2']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['2']) ? 'nav-treeview' : ''}`}>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "tournament-list" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/tournament-list");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Ludo
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
              )} */}
              {/* Table */}
              {accessObject?.getEightBallPoolLiteTour === true && (
                <li className={`nav-item mt-2 ${openMenus['10'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fas fa-trophy  mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Games Table
                      <i
                        className={` ${
                          (!openMenus['10']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['10']) ? 'nav-treeview' : ''}`}>
                    {/* ludo */}
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "ludo-tournament-list" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/ludo-tournament-list");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Ludo
                        </p>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "chess-tournament-list" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/chess-tournament-list");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Chess
                        </p>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "block-blast-tournament-list" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/block-blast-tournament-list");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Block Blast
                        </p>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "candy-blast-tournament-list" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/candy-blast-tournament-list");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Candy
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
              )}
              {/* Tickets */}
              {accessObject?.contactDetailsList === true && (
                <div className="nav-item">
                  <div
                    className={`nav-link ${
                      location.pathname.split("/")[1] === "ticket" &&
                      "active"
                    }`}
                    id="dashboard"
                    onClick={() => {
                      history("/ticket");
                    }}
                  >
                    <i
                      className="nav-icon fas fa fa-comments mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">Tickets</p>
                  </div>
                </div>
              )}
              {accessObject?.contactDetailsList === true && (
                <div className="nav-item">
                  <div
                    className={`nav-link ${
                      location.pathname.split("/")[1] === "games" &&
                      "active"
                    }`}
                    id="dashboard"
                    onClick={() => {
                      history("/games");
                    }}
                  >
                    <i
                      className="nav-icon fas fa fa-gamepad mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">Games</p>
                  </div>
                </div>
              )}
              {accessObject?.contactDetailsList === true && (
                <div className="nav-item">
                  <div
                    className={`nav-link ${
                      location.pathname.split("/")[1] === "task" &&
                      "active"
                    }`}
                    onClick={() => {
                      history("/task");
                      setShowPage(false);
                    }}
                  >
                    <i
                      className="nav-icon fas fa-receipt mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">Tasks</p>
                  </div>
                </div>
              )}
              {/* Notification */}
              {accessObject?.getEightBallPoolLiteTour === true && (
                <li className={`nav-item mt-2 ${openMenus['12'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fas fa-trophy  mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Notification
                      <i
                        className={` ${
                          (!openMenus['12']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['12']) ? 'nav-treeview' : ''}`}>
                    {/* Notification */}
                    {accessObject?.getNotificationList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "notification" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/notification");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Notification List
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* control */}
              {(accessObject?.getNotificationList === true ||
                accessObject?.getNotificationListSeparate === true ||
                accessObject?.getVersionListAndroid === true ||
                accessObject?.getVersionListIos === true ||
                accessObject?.getBotForm === true ||
                accessObject?.getRoomTier === true ||
                accessObject?.getBannerList === true ||
                accessObject?.getRestrictedArea === true) && (
                <li className={`nav-item mt-2 ${openMenus['6'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <SettingsInputSvideoIcon
                      className="mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Controls
                      <i
                        className={` ${
                          (!openMenus['6']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['6']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getBannerList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "banner" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/banner");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Banner
                          </p>
                        </div>
                      </li>
                    )}
                    {(accessObject?.getVersionListAndroid === true ||
                      accessObject?.getVersionListIos === true) && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "version" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/version");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Version
                          </p>
                        </div>
                      </li>
                    )}
                    {(accessObject?.getVersionListAndroid === true ||
                      accessObject?.getVersionListIos === true) && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] === "cms" &&
                            "active"
                          } d-flex`}
                          onClick={() => {
                            history("/cms");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            CMS
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "spin-wheel" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/spin-wheel");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Spin Wheel
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getRestrictedArea === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "restrictedarea" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/restrictedarea");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Restricted Area
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] === "poll" &&
                            "active"
                          } d-flex`}
                          onClick={() => {
                            history("/poll");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Poll
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] === "faq" &&
                            "active"
                          } d-flex`}
                          onClick={() => {
                            history("/faq");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Faq
                          </p>
                        </div>
                      </li>
                    )}
                    {/* {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "notice" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/notice");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Notice
                          </p>
                        </div>
                      </li>
                    )} */}
                    {/* {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "room-tier" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/room-tier");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Room Tier
                          </p>
                        </div>
                      </li>
                    )} */}
                    {/* {accessObject?.getRoomTier === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "games" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/games");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Games
                          </p>
                        </div>
                      </li>
                    )} */}
                    {/* <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] === "task" &&
                          "active"
                        } d-flex`}
                        onClick={() => {
                          history("/task");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Tasks
                        </p>
                      </div>
                    </li> */}
                    {/* <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "advertisement" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/advertisement");
                          setShowPage(false);
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Advertisement
                        </p>
                      </div>
                    </li> */}
                  </ul>
                </li>
              )}
              {/* Payment */}
              {(accessObject?.getHistoryList === true ||
                accessObject?.getAddCashList === true ||
                accessObject?.getPayoutList === true ||
                accessObject?.getBetList === true ||
                accessObject?.getWinList === true) && (
                <li className={`nav-item mt-2 ${openMenus['4'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fa fa-credit-card mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Payment
                      <i
                        className={` ${
                          (!openMenus['4']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['4']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getHistoryList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "history" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/history");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            History
                          </p>
                        </div>
                      </li>
                    )}
                    {/* {accessObject?.getAddCashList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "addcash" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/addcash", { state: { data: "All" } });
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Add Cash
                          </p>
                        </div>
                      </li>
                    )} */}
                    {accessObject?.getPayoutList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "payout" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/payout", { state: { data: "All" } });
                            setShowPage(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Payout
                          </p>
                        </div>
                      </li>
                    )}
                    {/* {accessObject?.getPayoutList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "reward" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/reward", { state: { data: "All" } });
                            setShowPage(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Reward
                          </p>
                        </div>
                      </li>
                    )} */}
                    {accessObject?.getBetList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] === "bet" &&
                            "active"
                          } d-flex`}
                          onClick={() => {
                            history("/bet");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Bet
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getWinList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] === "win" &&
                            "active"
                          } d-flex`}
                          onClick={() => {
                            history("/win");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Win
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* income */}
              {/* {(accessObject?.getIncomeList === true ||
                accessObject?.getBlockBlastIncomeList === true ||
                accessObject?.getCandyCreamIncomeList === true ||
                accessObject?.getLogicLineIncomeList === true ||
                accessObject?.getSmashBlockIncomeList === true ||
                accessObject?.getTicTacToeIncomeList === true ||
                accessObject?.getWordBookIncomeList === true ||
                accessObject?.getNumberPuzzleIncomeList === true ||
                accessObject?.getChessGameBitIncomeList === true) && (
                <li className="nav-item mt-2">
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <img
                      src={total_income_icon}
                      alt="income_icon"
                      className="nav-icon  mr-2"
                    />

                    <p className="sidebar-text-white">
                      Income
                      <i
                        className={` ${
                          (!openMenus['3']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['3']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getIncomeList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "income-details" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/income-details");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            All Income
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getChessGameBitIncomeList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "ludo-income" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/ludo-income");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Ludo Income
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )} */}
              {/* reports */}
              {(accessObject?.getReportPlayerList === true ||
                accessObject?.getReportHistoryList === true) && (
                <li className={`nav-item mt-2 ${openMenus['7'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <ReportIcon className="mr-2 sidebar-text-white" />
                    <p className="sidebar-text-white">
                      Reports
                      <i
                        className={` ${
                          (!openMenus['7']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['7']) ? 'nav-treeview' : ''}`}>
                    {accessObject?.getReportPlayerList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "reports-player" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/reports-player");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Player List
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getReportHistoryList === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "history-reports" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/history-reports");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            History List
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* game setting */}
              {(accessObject?.getSetting === true ||
                accessObject?.getSocial === true ||
                accessObject?.getBonus === true ||
                accessObject?.getGameHandle === true ||
                accessObject?.getGameVersion === true ||
                accessObject?.getWithdraw === true ||
                accessObject?.getAddMoney === true) && (
                <li className={`nav-item mt-2 ${openMenus['9'] ? 'menu-open' : ''}`}>
                  <div
                    className="nav-link"
                    onClick={(e) => {
    // Toggled menu
    const menuName = e.currentTarget.innerText.trim().split('\n')[0];
    const map = { 'Admin': '8', 'Player': '1', 'Tournament': '2', 'Games Table': '10', 'Notification': '12', 'Controls': '6', 'Payment': '4', 'Finance': '9', 'Contact us': '11', 'Game Setting': '9', 'Reports': '7' };
    const key = map[menuName];
    if (key) setOpenMenus(prev => prev[key] ? {} : { [key]: true });
}}
                  >
                    <i
                      className="nav-icon fas fa fa-cog mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">
                      Game Setting
                      <i
                        className={` ${
                          (!openMenus['9']) ? 'right fas fa-angle-left ' : 'right fas fa-angle-down'
                        }`}
                      />
                    </p>
                  </div>
                  <ul className={`nav ${(!openMenus['9']) ? 'nav-treeview' : ''}`}>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] === "bonus" &&
                          "active"
                        } d-flex`}
                        onClick={() => {
                          history("/bonus");
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Bonus
                        </p>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "withdraw" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/withdraw");
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Withdraw
                        </p>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div
                        className={`nav-link ${
                          location.pathname.split("/")[1] ===
                            "addmoney" && "active"
                        } d-flex`}
                        onClick={() => {
                          history("/addmoney");
                        }}
                      >
                        <p
                          className="mt-1  sidebar-menu-item"
                        >
                          Addmoney
                        </p>
                      </div>
                    </li>

                    {accessObject?.getSetting === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "game-setting" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/game-setting");
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Setting
                          </p>
                        </div>
                      </li>
                    )}
                    {accessObject?.getSocial === true && (
                      <li className="nav-item">
                        <div
                          className={`nav-link ${
                            location.pathname.split("/")[1] ===
                              "social" && "active"
                          } d-flex`}
                          onClick={() => {
                            history("/social");
                            setShowPage(false);
                          }}
                        >
                          <p
                            className="mt-1  sidebar-menu-item"
                          >
                            Social
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* contact Details */}
              {/* {accessObject?.contactDetailsList === true && (
                <div className="nav-item mb-5">
                  <div
                    className={`nav-link ${
                      location.pathname.split("/")[1] ===
                        "contact-details" && "active"
                    }`}
                    id="dashboard"
                    onClick={() => {
                      history("/contact-details");
                    }}
                  >
                    <i
                      className="nav-icon fas fa fa-comments mr-2 sidebar-text-white"
                    />
                    <p className="sidebar-text-white">Contact Details</p>
                  </div>
                </div>
              )} */}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
}
